export { ImageAtom, type ImageAtomProps } from "./ImageAtom";
